import { CicdJobs } from "~/pages/cicd/Jobs/CicdJobs";
import { Space } from "~/lib/types";

interface CicdJobsProps {
  space: Space;
}

const JobsEntryPage = ({ space }: CicdJobsProps) => {
  return <CicdJobs space={space} />;
};

export default JobsEntryPage;
